import React, {useState} from 'react'
import LogoHeader from './LogoHeader';
import BocesLogo from '../imgs/logo.png';
import LPASLogo from '../imgs/lpaslogo.png';

const Banner = ({homeUrl}) => {
    const [currentLogoClass, setCurrentLogoClass] = useState("banner-logo-start");
    const [currentTextClass, setCurrentTextClass] = useState("banner-text-start");
    const onLoad = () =>{
        setTimeout(function(){
            setCurrentLogoClass('banner-logo-end');
            setCurrentTextClass('banner-text-end');
        },250)
    }
    return (
        <div className="banner" onLoad={onLoad}>
            <LogoHeader src={BocesLogo} className={`banner-logo ${currentLogoClass}  unselectable`} linkUrl={homeUrl}/>
            <LogoHeader src={LPASLogo} width="280px" height="75px" className={`banner-text ${currentTextClass}  unselectable`} linkUrl={homeUrl}/>
            {/*<h1 className={`banner-text ${currentTextClass} unselectable`}>LPAS Intakes</h1>*/}
        </div>
    )
}

export default Banner
